import React from 'react';
import { FormikProps } from 'formik';
import Banner from '@cpg-its/ads.containers.banner';
import { FormField } from '../../../../../global/components/form-element/form-field';
import { DomesticPartnerWizard } from '../wizard/domestic-partner-wizard';
import { DividerSection } from '../../../../../global/components/layout/divider-section';
import { FormGroup } from '../../../../../global/components/layout/form-group';
import { ContentSpacer } from '../../../../../global/components/layout/generic-content-spacer';
import { WysiwygWithReactLink } from '../../../../../global/components/wysiwyg-with-react-link';


interface Props {
	formProps: FormikProps<any>;
	wizard: DomesticPartnerWizard;
}
export function DomesticPartnerDissolutionFields(props: Props) {
	const {
		formProps,
		wizard,
	} = props;

	const relationshipsProps = wizard?.getRelationShipSettings();
	return (
		<DividerSection sectionText={relationshipsProps?.dissolutionDomesticPartnershipTitle} removeDivider >
			<FormGroup>
				<FormField
					name='end_date'
					label={relationshipsProps?.relationshipEndDateLabel}
					component='datePicker'
					touched={formProps.touched}
					errors={formProps.errors}
					required
					autoWidth
				/>
				<FormField
					name='entity'
					label={relationshipsProps?.entityIssuingDissolutionLabel}
					component='input'
					errors={formProps.errors}
					touched={formProps.touched}
				/>
				<ContentSpacer>
					<Banner
						banner={{
							type: 'warning',
							label: <WysiwygWithReactLink content={relationshipsProps?.dissolutionWarningDescription} />,
						}}
					/>
				</ContentSpacer>
			</FormGroup>
		</DividerSection>
	);
}